<div class="activity" data-testid="activity">
    <div class="activity__table" data-testid="activity-table">
        <app-table
            [columns]="activityColumns"
            [data]="activityData"
            [tableTitle]="'Licenses'"
            [tableHeight]="'600px'"
            [paddingY]="'14px'"
            (actionClick)="onActionClick($event)"
            (cellClick)="onCellClick($event)"
            (selectionChange)="onSelectionChange($event)">
        </app-table>
    </div>
</div>
